import { useQuery } from '@tanstack/react-query';
import { earningsApi } from '@/api/earnings';

export function useEarningsSummary(as: 'driver' | 'sender' | 'receiver' | 'center' = 'driver') {
  return useQuery({
    queryKey: ['earnings', 'summary', as],
    queryFn: () => earningsApi.summary(as),
  });
}

export function useEarningsList(opts: { status?: 'pending' | 'released' } = {}) {
  return useQuery({
    queryKey: ['earnings', 'list', opts],
    queryFn: () => earningsApi.list(opts),
  });
}
